module.exports = __webpack_public_path__ + "img/iw_get.4533918.png";